import { useEffect } from "react";

interface Props {
  testimony: {
    image: string;
    fullText: string;
  };
  onClose: () => void;
}

const TestimonyModal: React.FC<Props> = ({ testimony, onClose }) => {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <div className="fixed inset-0 z-50 flex items-end md:items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal */}
      <div
        className="
          relative
          bg-white
          w-full
          md:max-w-4xl
          h-[92vh]
          md:h-[85vh]
          rounded-t-3xl md:rounded-3xl
          shadow-2xl
          overflow-y-auto md:overflow-hidden
          flex flex-col md:flex-row
        "
      >
        {/* Close */}
        <button
          onClick={onClose}
          className="
            absolute
            top-3 right-3
            z-30
            w-8 h-8
            flex items-center justify-center
            rounded-full
            bg-white
            text-gray-600
            shadow
          "
        >
          ✕
        </button>

        {/* ===== IMAGE ===== */}
        <div
          className="
            w-full
            md:w-[40%]
            bg-gray-100
            flex justify-center
            pt-5 pb-3 md:p-6
          "
        >
          <img
            src={testimony.image}
            alt="testimonial"
            className="
              w-auto
              max-h-[260px]
              sm:max-h-[300px]
              md:max-h-full
              rounded-2xl
              object-contain
            "
          />
        </div>

        {/* ===== CONTENT ===== */}
        <div className="flex-1 flex flex-col">
          <div
            className="
              flex-1
              md:overflow-y-auto
              px-4 sm:px-6 md:px-8
              py-4
            "
          >
            <p
              className="
                text-gray-700
                text-sm sm:text-base
                leading-relaxed
                whitespace-pre-line
                max-w-prose
                mx-auto
              "
            >
              {testimony.fullText}
            </p>
          </div>

          {/* Footer */}
          <div className="border-t px-4 sm:px-6 py-3 bg-gray-50 sticky bottom-0">
            <button
              onClick={onClose}
              className="
                w-full
                sm:w-auto
                px-6 sm:px-8
                py-2
                rounded-xl
                bg-primary
                text-white
                text-sm
                font-medium
              "
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonyModal;
